import {
    apiRequest,
    pencantumanGelarUpdate,
    pencantumanGelarDetail,
    masterEducation
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", pencantumanGelarUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", pencantumanGelarDetail, {
            params: query
        }, true)
    }

    fetchEducation= async (query) => {
        return await apiRequest("get", masterEducation, {
            params: query
        }, true)
    }
}

export default UpdateRepository